import FilterTag from "./FilterTag";

export default FilterTag;
